import { Badge, FlexLayout } from '@deity/falcon-ui';
import styles from './EndpointBadges.module.css';

const xxs: any = 'xxs';

export const EndpointMethodBadge = ({ schema }: { schema: any }) => {
  if (!schema) {
    return null;
  }
  const methodStyle = method => {
    if (method === 'GET') {
      return styles.getStyle;
    }
    if (method === 'POST') {
      return styles.postStyle;
    }
    if (method === 'PUT') {
      return styles.putStyle;
    }
  };

  return (
    <FlexLayout width="full">
      <Badge py={xxs} fontWeight="bold" className={methodStyle(schema.method)}>
        {schema.method}
      </Badge>
    </FlexLayout>
  );
};
